export type HeadingScope = "float" | "submission";

export interface HeadingDefaults {
  details: string;
  portfolio: string;
  skills: string;
}

/**
 * The headings used when a recruiter hasn't set an override. These are the
 * strings the Float and Submission views fall back to.
 */
export const BUILT_IN_HEADINGS: HeadingDefaults = {
  details: "Details",
  portfolio: "Portfolio",
  skills: "Skills",
};

export const HEADING_KEYS = ["details", "portfolio", "skills"] as const;

const toHeading = (value: unknown): string =>
  typeof value === "string" ? value.trim() : "";

/**
 * The recruiter's overrides only — keys they haven't set are omitted, so a
 * new Float or Submission is seeded with nothing when there's no override.
 */
export function getHeadingOverrides(
  recruiter: Record<string, unknown> | null | undefined,
  scope: HeadingScope
): Partial<HeadingDefaults> {
  const overrides: Partial<HeadingDefaults> = {};

  HEADING_KEYS.forEach((key) => {
    const value = toHeading(recruiter?.[`${scope}_${key}_heading`]);
    if (value) {
      overrides[key] = value;
    }
  });

  return overrides;
}

/**
 * The section headings a new Float or Submission starts with, taking the
 * recruiter's overrides from Settings → Outreach into account.
 */
export default function getHeadingDefaults(
  recruiter: Record<string, unknown> | null | undefined,
  scope: HeadingScope
): HeadingDefaults {
  return { ...BUILT_IN_HEADINGS, ...getHeadingOverrides(recruiter, scope) };
}
